import { Navigation, Clock, Tag, MapPin } from "lucide-react";
import { t, locale } from "@/i18n";
import { BigButton } from "@/components/BigButton";

export const isActive = (p) => {
  const n = new Date();
  const cur = `${String(n.getHours()).padStart(2, "0")}:${String(n.getMinutes()).padStart(2, "0")}`;
  return cur >= p.start && cur <= p.end;
};

const price = (v) => new Intl.NumberFormat(locale(), { style: "currency", currency: "EUR" }).format(v);

const PromoCard = ({ p, onGo }) => {
  const active = isActive(p);
  return (
    <div className="nv-card p-4 flex flex-col sm:flex-row sm:items-center gap-3" data-testid={`promo-${p.id}`} style={active ? { borderColor: "#ef0298" } : undefined}>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="font-display text-3xl font-extrabold text-[#ef0298]" data-testid={`promo-price-${p.id}`}>{price(p.price_eur)}</span>
          {active && <span className="rounded-full bg-[#10b981] text-[#0b0f17] px-3 py-0.5 text-sm font-bold uppercase" data-testid={`promo-active-${p.id}`}>{t("Disponibile ora")}</span>}
        </div>
        <p className="font-display text-2xl font-extrabold uppercase">{t(p.title)}</p>
        <p className="text-slate-300">{t(p.description)}</p>
        <p className="text-base font-semibold flex items-start gap-1 mt-1" data-testid={`promo-location-${p.id}`}>
          <MapPin className="h-5 w-5 text-[#4accff] shrink-0 mt-0.5" />
          <span>{p.place}{p.road ? ` · ${p.road}` : ""} · {p.along_km != null ? t("tra {km} km sul percorso", { km: Math.round(p.along_km) }) : `${p.distance_km.toFixed(1)} km`}{p.toward ? ` · ${t("direzione {d}", { d: p.toward })}` : ""}</span>
        </p>
        <p className="text-slate-400 text-sm flex flex-wrap gap-x-3 mt-1">
          <span className="flex items-center gap-1"><Clock className="h-4 w-4" /> {t("Dalle {a} alle {b}", { a: p.start, b: p.end })}</span>
          <span className="flex items-center gap-1"><Tag className="h-4 w-4" /> {t("Promozione di esempio")}</span>
        </p>
      </div>
      <div className="sm:w-56"><BigButton testId={`promo-go-${p.id}`} icon={Navigation} color="#ef0298" label={t("Portami qui")} onClick={() => onGo({ ...p, name: p.place })} /></div>
    </div>
  );
};

export const PromoList = ({ items, onGo }) => {
  const sorted = [...items].sort((a, b) => isActive(b) - isActive(a) || (a.along_km ?? a.distance_km) - (b.along_km ?? b.distance_km));
  return (
    <div className="space-y-3" data-testid="promo-list">
      {sorted.map((p) => <PromoCard key={p.id} p={p} onGo={onGo} />)}
    </div>
  );
};
